<template>
  <router-view />
</template>
<script lang="ts" setup>
//TODO
console.log("9-6-12:42");
</script>

<style lang="less">
.braintree-placeholder {
  display: none;
}
.braintree-method--active {
  padding: 2.5px 10px; /* px-to-viewport-ignore */
}
// [data-braintree-id="methods-label"] {
//   display: none;
// }
// [data-braintree-id="methods"] {
//   display: none !important;
// }
html {
  font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", Helvetica,
    Segoe UI, Arial, Roboto, "PingFang SC", miui, "Hiragino Sans GB",
    "Microsoft Yahei", sans-serif;
  height: 100%;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0) !important;
  -webkit-tap-highlight-color: transparent !important;
}

body {
  background: #fff;
  height: 100%;
}
#app {
  height: 100%;
}
* {
  margin: 0;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
